
import { ReducerRegistry } from '../base/redux';

import { TOGGLE_CONNECTION_CONTAINER, TOGGLE_REMOTE_VIDEO_MENU } from './actionTypes';

/**
 * The default state of the feature video-menu.
 */
const DEFAULT_STATE = {
    remoteVideoMenuItem: {
        remoteVideoMenuVisible: false,
        remoteVideoMenuParticipant: null,
        isFromParticipantsPane: false,
        toggleObjectFit: null,
        currentObjectFit: false,
        pressPosition: null
    },
    isConnectionContainer: false,
    participantIDConnection: null
};

/**
 * Listen for actions that contain the video-menu state that is to be reduced.
 */
ReducerRegistry.register('features/video-menu', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case TOGGLE_REMOTE_VIDEO_MENU:
        return {
            ...state,
            remoteVideoMenuItem: {
                remoteVideoMenuVisible: action.visible,
                remoteVideoMenuParticipant: action.visible ? action.participant : null,
                isFromParticipantsPane: action.isFromParticipantsPane,
                toggleObjectFit: action.visible ? action.toggleObjectFit : null,
                currentObjectFit: action.visible ? action.currentObjectFit : false,
                pressPosition: action.visible ? action.pressPosition : null
            }
        };
    case TOGGLE_CONNECTION_CONTAINER:
        return {
            ...state,
            participantIDConnection: action.participantIDConnection,
            isConnectionContainer: action.isConnectionContainer
        };

    default:
        return state;
    }
});
